/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TechStackCompanyPageRequestDto } from '../models/tech-stack-company-page-request-dto';
import { TechStackCompanyPageResponseDto } from '../models/tech-stack-company-page-response-dto';
import { TechStackCompanyProductPageRequestDto } from '../models/tech-stack-company-product-page-request-dto';
import { TechStackCompanyProductPageResponseDto } from '../models/tech-stack-company-product-page-response-dto';

@Injectable({
  providedIn: 'root',
})
export class StackCompanyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findStackCompaniesProducts
   */
  static readonly FindStackCompaniesProductsPath = '/techstack-companies/products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStackCompaniesProducts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompaniesProducts$Response(params?: {
    body?: TechStackCompanyProductPageRequestDto
  }): Observable<StrictHttpResponse<TechStackCompanyProductPageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, StackCompanyService.FindStackCompaniesProductsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackCompanyProductPageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStackCompaniesProducts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompaniesProducts(params?: {
    body?: TechStackCompanyProductPageRequestDto
  }): Observable<TechStackCompanyProductPageResponseDto> {

    return this.findStackCompaniesProducts$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackCompanyProductPageResponseDto>) => r.body as TechStackCompanyProductPageResponseDto)
    );
  }

  /**
   * Path part for operation findStackCompanies
   */
  static readonly FindStackCompaniesPath = '/techstack-companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStackCompanies$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompanies$Json$Response(params?: {
    body?: TechStackCompanyPageRequestDto
  }): Observable<StrictHttpResponse<TechStackCompanyPageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, StackCompanyService.FindStackCompaniesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackCompanyPageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStackCompanies$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompanies$Json(params?: {
    body?: TechStackCompanyPageRequestDto
  }): Observable<TechStackCompanyPageResponseDto> {

    return this.findStackCompanies$Json$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackCompanyPageResponseDto>) => r.body as TechStackCompanyPageResponseDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStackCompanies$Csv()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompanies$Csv$Response(params?: {
    body?: TechStackCompanyPageRequestDto
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, StackCompanyService.FindStackCompaniesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/csv'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStackCompanies$Csv$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompanies$Csv(params?: {
    body?: TechStackCompanyPageRequestDto
  }): Observable<string> {

    return this.findStackCompanies$Csv$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
